<template>
  <stacked-input
    :label="i18n.sl"
    :required="required"
    :error="errors.sl"
    :help="options.min + ' → ' + options.max"
  >
    <input
      type="number"
      :required="required"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :min="options.min"
      :max="options.max"
    />
  </stacked-input>
</template>

<script>
import StackedInput from "../../../../Design/Forms/StackedInput";

export default {
  props: ["i18n", "required", "value", "errors", "options"],
  components: { StackedInput },
};
</script>
